import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "@/core/theme/variables.css";
import { tooltipDirective } from "@/shared/directives/tooltip";
import { bootMsal } from "@/core/auth/msalConfig";
import { authService } from "@/modules/auth/services/auth.service";

const app = createApp(App);

app.use(router);
app.directive("tooltip", tooltipDirective);

async function bootstrapApp() {
  // 1. Revisar si venimos de un redirect manual de Google (Flujo OAuth2)
  const urlParams = new URLSearchParams(window.location.search);
  const googleCode = urlParams.get("code");
  const state = urlParams.get("state");

  if (googleCode && state !== null) {
    console.log("Redirección de Google completada. Enviando al backend...");

    let invitationCode: string | undefined;
    let action: "LOGIN" | "REGISTER" = "LOGIN";

    try {
      const decodedState = JSON.parse(atob(state));
      invitationCode = decodedState.code;
      action = decodedState.action;
    } catch {
      // Fallback por si hay URLs cacheadas viejas
      invitationCode = state === "home" ? undefined : state;
    }

    // Limpiamos la URL para seguridad y estética
    window.history.replaceState({}, document.title, window.location.pathname);

    try {
      // Esperamos la respuesta del backend
      const serverResponse = await authService.googleAuth({
        authCode: googleCode,
        redirectUri: window.location.origin,
        invitationCode,
        action,
      });

      const hasCompany = serverResponse.hasCompany;
      const roles = serverResponse.roles || [];

      if (hasCompany === false && roles.includes("ADMIN")) {
        window.location.href = "/register?step=company-setup";
      } else {
        window.location.href = "/dashboard";
      }
      return;
    } catch (err) {
      console.error("Error al autenticar con Google en el backend:", err);
    }
  }

  // 2. Revisar MSAL (Microsoft)
  // bootMsal ya hace el await interno y el redirect si encuentra hash
  await bootMsal();

  // 3. Si no hubo redirecciones de autenticación pendientes, montamos la interfaz
  app.mount("#app");
}

bootstrapApp();
